<template>
  <v-data-table
    :headers="headers"
    :items="settings"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>General Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="accent"
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              New Setting
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h5 accent lighten-2">
              <span>{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="text-center"
                  >
                    <v-form
                      ref="settingform"
                      lazy-validation
                    >
                      <v-text-field
                        v-model="editedItem.name"
                        label="Setting Name"
                        outlined
                        :rules="[rules.required]"
                        :disabled="editedIndex !== -1"
                      />
                      <v-text-field
                        v-model="editedItem.value"
                        label="Setting Value"
                        outlined
                        :rules="[rules.required]"
                      />
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="close"
              >
                CANCEL
              </v-btn>
              <v-btn
                color="accent"
                @click="save"
              >
                CONFIRM
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 accent lighten-2">Delete Setting</v-card-title>
            <v-card-text>
              <v-container>
                <v-alert
                  type="warning"
                  outlined
                  prominent
                  text
                >
                  This will delete the following setting from the database. Are you sure you want to continue?
                </v-alert>
                <p class="text-h4 text-center">{{ editedItem.name }} : {{ editedItem.value }}</p>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDelete">Cancel</v-btn>
              <v-btn color="accent"  @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'SettingsTab',
    data () {
      return {
        dialog: false,
        dialogDelete: false,
        headers: [
          { text: 'Setting Name', value: 'name' },
          { text: 'Setting Value', value: 'value' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
        rules: {
          required: value => !!value || 'Required.',
        },
        editedItem: {
          name: '',
          value: ''
        },
        defaultItem: {
          name: '',
          value: ''
        },
        editedIndex: -1,
      }
    },
    computed: {
      settings () {
        return this.$store.getters['settings/settings_array']
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Setting' : 'Edit Setting'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    methods: {
      editItem (item) {
        this.editedIndex = this.settings.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.settings.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.deleteSetting(this.editedItem)
        this.closeDelete()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        if (this.$refs.settingform.validate()) {
          if (this.editedIndex > -1) {
            this.updateSetting(this.editedItem)
          } else {
            this.createSetting(this.editedItem)
          }
          this.close()
        }
      },
      createSetting: function (settingData) {
        axios
          .post(
            `${host}/v2/settings/new`,
            settingData,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: 'Setting created', color: 'success', timeout: 5000 })
            setTimeout(() => this.$store.dispatch('settings/load'), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      updateSetting: function (settingData) {
        axios
          .put(
            `${host}/v2/settings/update`,
            settingData,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: 'Setting updated', color: 'success', timeout: 5000 })
            setTimeout(() => this.$store.dispatch('settings/load'), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      deleteSetting: function (settingData) {
        axios
          .delete(
            `${host}/v2/settings/remove`,
            {
              headers: authHeader(),
              data: settingData,
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: 'Setting deleted', color: 'success', timeout: 5000 })
            setTimeout(() => this.$store.dispatch('settings/load'), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
    }
  }
</script>